import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useBookingContext } from '@providers/booking'
import { getServiceTypeByName } from '@shared/service_types'
import { useClientLocationBookingConf } from 'service-api/src/hooks/use_client_location_booking_conf'
import { isEmpty } from 'components-ui/src/shared/common'

export const useBookingConf = () => {
  const bookingCtx = useBookingContext()
  const { accountName: locationName = '' } = useParams()
  const standaloneGroom = bookingCtx.state.serviceTypeName === 'grooming'
  const st = getServiceTypeByName('grooming', bookingCtx.state.data.serviceTypes)
  const notHasInStayBookingConf = isEmpty(bookingCtx.state.data.inStayBookingConf)
  const needsInStayBookingConf = !standaloneGroom && notHasInStayBookingConf

  const serviceTypeId = st?.id
  const shouldFetch = Boolean(needsInStayBookingConf && serviceTypeId)
  const bookingConf = useClientLocationBookingConf(locationName, shouldFetch ? serviceTypeId : undefined)

  useEffect(() => {
    if (!shouldFetch) return
    if (!bookingConf.isSuccess) return

    const first = bookingConf.data?.results?.[0]
    if (!first) return

    bookingCtx.dispatch({
      type: 'SET_INSTAY_BOOKING_CONFIG',
      payload: first,
    })
  }, [bookingConf.data, bookingConf.isSuccess, bookingCtx, shouldFetch])

  const isLoading = useMemo(() => {
    // For standalone grooming we don't need the in-stay booking config at all.
    if (standaloneGroom) return false
    // If we don't need to fetch (already have config, or missing serviceTypeId), don't block the UI.
    if (!shouldFetch) return false
    return bookingConf.isLoading
  }, [bookingConf.isLoading, shouldFetch, standaloneGroom])

  const isError = useMemo(() => {
    if (!shouldFetch) return false
    return bookingConf.isError
  }, [bookingConf.isError, shouldFetch])

  return {
    isLoading,
    isError,
    bookingConf: bookingConf.data,
  }
}
